export default __webpack_public_path__ + "static/mountain-5a89d28721a69b4346577b97084baf93.png";